const qrCodeImageSize = 1500;

export const convertToMb = (size: number) => {
    return `${size / 1024 / 1024}MB`;
};

const downloadImage = (name: string, url: string) => {
    const aEl = document.createElement('a');
    aEl.href = url;
    aEl.download = `QR_Code_${name}.png`;
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
};

export const downloadQRCode = async (name: string, elementId = 'qrCodeEl') => {
    const qrCodeEl = document.getElementById(elementId);
    if (qrCodeEl) {
        const qrCodeElName = qrCodeEl.nodeName ? qrCodeEl.nodeName.toLowerCase() : '';
        if (qrCodeElName === 'canvas') {
            const qrCodeURL = (qrCodeEl as HTMLCanvasElement)
                .toDataURL('image/png')
                .replace('image/png', 'image/octet-stream');
            downloadImage(name, qrCodeURL);
        } else if (qrCodeElName === 'svg') {
            const svgElement = qrCodeEl as unknown as SVGSVGElement;
            const svgURL = new XMLSerializer().serializeToString(svgElement);
            // Replace xlink:href with href https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:href
            const finalSvgURL = svgURL.replace(/xlink:href/g, 'href');
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = qrCodeImageSize;
                canvas.height = qrCodeImageSize;
                const context = canvas.getContext('2d');
                if (context) {
                    context.drawImage(image, 0, 0, qrCodeImageSize, qrCodeImageSize);
                    const qrCodeURL = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
                    downloadImage(name, qrCodeURL);
                }
            };
            image.src = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(finalSvgURL);
        }
    }
};
